module.exports = __webpack_public_path__ + "assets/img/haoyoukuaibao-43f6fc31.png";